import { defineComponent, inject, ref } from 'vue';
import SButton from '@/components/stemdo-components/s-button/SButton.vue';
import SModalCentered from '@/components/stemdo-components/s-modal-centered/SModalCentered.vue';
import { ButtonGroupModals } from '../../../buttonsGroup';
import { TeamRequest } from '@/shared/model/team-request.model';
import TeamRequestService from '@/sections/admin/entities/team-request/team-request.service';
import { RequestStatus } from '@/shared/model/enumerations/request-status.model';
import { useI18N } from '@/plugins/i18n';

export default defineComponent({
  props: {
    onSuccess: {
      type: Function,
      required: true
    },
    onError: {
      type: Function,
      required: true
    },
    teamRequest: {
      type: Object as () => TeamRequest,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    refreshTeamRequest: {
      type: Function,
      required: true
    }
  },
  components: {
    SButton,
    SModalCentered
  },
  setup(props) {
    const teamRequestService: TeamRequestService = inject('teamRequestService');
    const customModalProps = { bodyPaddingY: 0, fullWidthFooter: true };
    const i18n = useI18N();
    const errorPopUp = ref(false);
    const loading = ref(false);

    const handleClose = () => {
      if (!loading.value) {
        props.onClose(ButtonGroupModals.TR_APPROVED_BY_MANAGER);
      }
    };
    const handleAccept = async () => {
      loading.value = true;
      try {
        if (props.teamRequest.status === RequestStatus.VALIDATED) {
          await teamRequestService.approveAndPartialUpdate(props.teamRequest);
          props.onSuccess(i18n.t('teamRequestDetail.modal.manager.approveTeamRequest.popUp'));
          props.refreshTeamRequest();
          props.onClose(ButtonGroupModals.TR_APPROVED_BY_MANAGER);
        }
      } catch (error) {
        props.onError(i18n.t('teamRequestDetail.modal.manager.approveTeamRequest.error'));
        props.refreshTeamRequest();
        props.onClose(ButtonGroupModals.TR_APPROVED_BY_MANAGER);
        console.error(error);
      } finally {
        loading.value = false;
      }
    };

    return {
      customModalProps,
      loading,
      handleClose,
      handleAccept
    };
  }
});
